import { Event_ } from '../Event_';
export class ScrollEvent_ extends Event_ {
    get detail() {
        return this.reactEvent.detail;
    }
}
